import { ISubscription } from "../interfaces/subscription.interface";

export class Subscription<E> implements ISubscription<E> {
  constructor(
    readonly event: E,
    readonly callback: (data: any) => void,
    public readonly unsubscribe: () => void
  ) {}

  private _unsubscribeOnEmit = false;

  public notify(data: any) {
    this.callback(data);
    if (this._unsubscribeOnEmit) this.unsubscribe();
  }

  public unsubscribeOnEmit() {
    this._unsubscribeOnEmit = true;
  }
}